import { render } from "./CombustibleDialog.vue?vue&type=template&id=49c548aa"
import script from "./CombustibleDialog.vue?vue&type=script&lang=js"
export * from "./CombustibleDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__